<div>
    <div class="row">
        <div class="col-md-2 sidebar" style="background-color: #2D5697;">
            <a href="" class="nav-link">
                <img src="../../../../../../assets/icons/logo.png" id="navitem" width="34px" alt="" loading="lazy">

            </a>
        </div>
        <div class="col-md-10 main-nav-container">
            <div class="col-md-12 ">
                <div class="outlet">
                    <div class="logo-icon">
                        <img src={{logoUrl}} id="navitem" width="34px" alt="" loading="lazy">
                    </div>
                    <div *ngIf="loggedUser">
                        <div class="outlet-name">
                            {{storeName | titlecase}}
                        </div>
                    </div>
                    <div *ngIf="!loggedUser" class="outlet-name"></div>
                </div>
                <div *ngIf="loggedUser" style="font-size: 14px;"> Logged in as : {{loggedUser.user_roles.role.name }}
                </div>
                <div class=" main-nav-container2 ">
                    <ul class="nav nav-pills flex-column " id="myTab" role="tablist">
                        <li class="nav-item" appCanAccess [accessPolicy]="[1]">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/home" role="tab"
                                aria-controls="home" aria-selected="false" #dashboard="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="dashboard.isActive ? '../../../../../../assets/icons/categoryActive.png' : '../../../../../../assets/icons/category.png'"
                                    class="nav-icon" /> Dashboard</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[2,3]">
                            <a class="nav-link" id="home-tab" data-toggle="tab" routerLink="/orders" role="tab"
                                aria-controls="orders" aria-selected="false" #orders="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="orders.isActive ? '../../../../../../assets/icons/ordersActive.png' : '../../../../../../assets/icons/ordersInactive.png'"
                                    class="nav-icon" /> Orders</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[5,6,7]">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/menu" role="tab"
                                aria-controls="profile" *ngIf="!isNewCustomer" aria-selected="false"
                                #menu1="routerLinkActive" [routerLinkActive]="['active']">
                                <img [src]="menu1.isActive ? '../../../../../../assets/icons/documentActive.png' : '../../../../../../assets/icons/document.png'"
                                    class="nav-icon" />Menu</a>
                            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/menu/setup" role="tab"
                                aria-controls="profile" *ngIf="isNewCustomer" aria-selected="false"
                                #menu2="routerLinkActive" [routerLinkActive]="['active']">
                                <img [src]="menu2.isActive ? '../../../../../../assets/icons/documentActive.png' : '../../../../../../assets/icons/document.png'"
                                    class="nav-icon" />Menu</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[4,8]">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/items" role="tab"
                                aria-controls="profile" aria-selected="false" #items="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="items.isActive ? '../../../../../../assets/icons/itemsActive.png' : '../../../../../../assets/icons/items.png'"
                                    class="nav-icon" />Items</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[4,8]">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" routerLink="/categories" role="tab"
                                aria-controls="profile" aria-selected="false" #categories="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="categories.isActive ? '../../../../../../assets/icons/categoriesActive.png' : '../../../../../../assets/icons/categories.png'"
                                    class="nav-icon" />Categories</a>
                        </li>
                        <li *ngIf="locationAccess" class="nav-item" appCanAccess [accessPolicy]="[10,11]" appShowHide>
                            <a class="nav-link" id="contact-tab" data-toggle="tab" routerLink="/locations" role="tab"
                                aria-controls="contact" aria-selected="false" #location="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="location.isActive ? '../../../../../../assets/icons/locationActive.png' : '../../../../../../assets/icons/locationInactive.png'"
                                    class="nav-icon" />Locations</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[17,18]">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" routerLink="/snooze" role="tab"
                                aria-controls="contact" aria-selected="false" #snooze="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="snooze.isActive ? '../../../../../../assets/icons/snoozeActive.png' : '../../../../../../assets/icons/snoozeInactive.png'"
                                    class="nav-icon" />Snooze</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[15,16]">
                            <a class="nav-link" id="table-booking-tab" data-toggle="tab" routerLink="/tableReservation"
                                role="tab" aria-controls="contact" aria-selected="false"
                                #tableReservation="routerLinkActive" [routerLinkActive]="['active']">
                                <img [src]="tableReservation.isActive ? '../../../../../../assets/icons/bookingActive.png' : '../../../../../../assets/icons/bookingInactive.png'"
                                    class="nav-icon" />Bookings</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[15,16]">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" routerLink="/users" role="tab"
                                aria-controls="contact" aria-selected="false" #users="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="users.isActive ? '../../../../../../assets/icons/userActive.png' : '../../../../../../assets/icons/userInactive.png'"
                                    class="nav-icon" />Users</a>
                        </li>
                        <li class="nav-item" appCanAccess [accessPolicy]="[12,13,14]">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" routerLink="/settings" role="tab"
                                aria-controls="contact" aria-selected="false" #setting="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="setting.isActive ? '../../../../../../assets/icons/settingActive.png' : '../../../../../../assets/icons/settingInactive.png'"
                                    class="nav-icon" />Settings</a>
                        </li>
                        <li class="nav-item" *ngIf="isAdminUser">
                            <a *ngIf=" brandsAvailable" class="nav-link" id="contact-tab" data-toggle="tab"
                                routerLink="/webshopV2/allBrands" role="tab" aria-controls="contact"
                                aria-selected="false" #webShop="routerLinkActive" [routerLinkActive]="['active']">
                                <img [src]="webShop.isActive ? '../../../../../../assets/icons/webshopActive.png' : '../../../../../../assets/icons/webshopInactive.png'"
                                    class="nav-icon" />Webshop</a>
                            <a *ngIf=" !brandsAvailable" class="nav-link" id="contact-tab" data-toggle="tab"
                                routerLink="/webshopV2" role="tab" aria-controls="contact" aria-selected="false"
                                #webShop="routerLinkActive" [routerLinkActive]="['active']">
                                <img [src]="webShop.isActive ? '../../../../../../assets/icons/webshopActive.png' : '../../../../../../assets/icons/webshopInactive.png'"
                                    class="nav-icon" />Webshop</a>
                        </li>
                        <li class="nav-item" *ngIf="isAdminUser" >
                            <a class="nav-link" id="contact-tab" data-toggle="tab" routerLink="/payments" role="tab"
                                aria-controls="contact" aria-selected="false" #payments="routerLinkActive"
                                [routerLinkActive]="['active']">
                                <img [src]="payments.isActive ? '../../../../../../assets/icons/paymentActive.png' : '../../../../../../assets/icons/paymentInactive.png'"
                                    class="nav-icon" />Payments</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-md-12 btnCol">
                <li class="logoutBtn" id="li-btn-add" [routerLinkActive]="['active']"
                    [routerLinkActiveOptions]="{exact:true}">
                    <button type="button" class="span-2" (click)="logout()" id="btn-add-entry">Logout</button>
                    <p class="version">{{appVersion}}</p>
                </li>

            </div>
        </div>

    </div>
</div>

<!-- /.container -->